import { NsPill } from 'components/common/ns-pill/NsPill';
import type { NsPillProps } from 'components/common/ns-pill/NsPill';
import { usePillFeatures } from 'components/direct-sales/quote/hooks/useTariffFeatures';

type TariffPillProps = {
  product?: object;
};

type PillData = {
  pillColour?: NsPillProps['colour'];
  pillIcon?: NsPillProps['icon'];
  pillDescription?: NsPillProps['children'];
};

export const TariffPill = ({ product }: TariffPillProps) => {
  const pillFeatures = usePillFeatures(product);

  if (!pillFeatures.length) {
    return <br />;
  }

  return pillFeatures
    .sort((a, b) => parseInt(`${a?.order}`, 10) - parseInt(`${b?.order}`, 10))
    .map((pill, index) => {
      let pillData: PillData = {};
      try {
        pillData = JSON.parse(`${pill.description}`);
      } catch (e) {
        console.error(e);
      }
      const { pillColour, pillIcon, pillDescription } = pillData;

      if (!pillDescription) {
        return null;
      }

      return (
        <NsPill slot="pill" colour={pillColour} icon={pillIcon} key={index}>
          {pillDescription}
        </NsPill>
      );
    });
};
